import ProductsGrid from "@/app/shared/explore-listing";
import ListingFilters from "@/app/shared/explore-listing/listing-filters";
import PageHeader from "@/app/shared/page-header";
import { metaObject } from "@/config/site.config";
import routes from "@/routers/routes";

export const metadata = {
    ...metaObject("Real State"),
};

const pageHeader = {
    title: "Search & Filters",
    breadcrumb: [
        {
            name: "Pages",
        },
        {
            href: routes.searchAndFilter.realEstate,
            name: "Search & Filters",
        },
        {
            name: "Real Estate",
        },
    ],
};

export default function RealEstatePage() {
    return (
        <div className="@container">
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            />
            <ListingFilters className="mb-6" />
            <ProductsGrid />
        </div>
    );
}
